/**
 * Rendering markdown per i report delle analisi AI (SPEC-007).
 *
 * `marked` + `dompurify`: entrambe librerie minime, senza dipendenze proprie
 * (a differenza dello stack remark/unified di `react-markdown`), scelta
 * deliberata per non appesantire un frontend che oggi ha solo quattro
 * dipendenze di runtime. Il markdown viene generato da un LLM: mai renderlo
 * senza sanitizzazione, anche se la fonte è "nostra" (il testo può comunque
 * incorporare frammenti di pagine web scrapate durante l'analisi).
 */

import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import './markdown.css';

marked.setOptions({ gfm: true, breaks: false });

export function Markdown({ content }: { content: string }) {
  const html = useMemo(() => {
    const raw = marked.parse(content, { async: false });
    return DOMPurify.sanitize(raw);
  }, [content]);

  return <div className="markdown" dangerouslySetInnerHTML={{ __html: html }} />;
}
